import React, { useState } from "react";
import Nav from "../shared/Nav";
import Footer from "../shared/Footer";
import { SOLUTIONS } from "../shared/constants";
import "../assets/css/variables.css";
import "../assets/css/global.css";
import "../assets/css/pages.css";

const CONTACT_DETAILS = [
  { icon: "📧", label: "Email", val: "acceliaclinicalsolution@gmail.com" },
  { icon: "📞", label: "Phone", val: "+91 8282986162" },
  { icon: "📍", label: "Headquarters", val: "Kolkata, West Bengal, India" },
  { icon: "🕐", label: "Response Time", val: "Within 24 business hours" },
];

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    country: "",
    service: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(
        "https://accelia-backend.onrender.com/api/contacts",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        },
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Submission failed");
      setSubmitted(true);
      setForm({
        name: "",
        email: "",
        phone: "",
        company: "",
        country: "",
        service: "",
        message: "",
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <>
      <Nav />
      <div className="contact-page">
        {/* ── Hero + Form combined ── */}
        <div className="contact-top">
          <div className="contact-top__inner">
            {/* Left */}
            <div className="contact-left">
              <div className="sec-tag sec-tag--gold">Contact Us</div>
              <h1 className="contact-left__title">
                Let's Work
                <br />
                Together
              </h1>
              <p className="contact-left__sub">
                Whether you're a sponsor, CRO, or institution looking to partner
                with a high-performing SMO — we're ready to support your next
                clinical trial.
              </p>

              <div className="contact-details">
                {CONTACT_DETAILS.map(({ icon, label, val }, i) => (
                  <div key={i} className="c-detail">
                    <div className="c-icon">{icon}</div>
                    <div className="c-text">
                      <p className="c-label">{label}</p>
                      <p className="c-val">{val}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — Form */}
            <div className="contact-right">
              <div className="c-form">
                <h2 className="c-form__title">Send a Message</h2>
                <p className="c-form__sub">
                  We'll get back to you within 24 hours.
                </p>

                {submitted ? (
                  <div className="form-success">
                    <div className="form-success__icon">✅</div>
                    <h3>Message Sent!</h3>
                    <p>We'll get back to you within 24 business hours.</p>
                    <button
                      className="sub-btn"
                      style={{ marginTop: 22 }}
                      onClick={() => setSubmitted(false)}
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="form-row">
                      <div className="f-grp">
                        <label>Full Name *</label>
                        <input
                          required
                          placeholder="Your full name"
                          value={form.name}
                          onChange={update("name")}
                        />
                      </div>
                      <div className="f-grp">
                        <label>Email *</label>
                        <input
                          type="email"
                          required
                          placeholder="your@email.com"
                          value={form.email}
                          onChange={update("email")}
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="f-grp">
                        <label>Company / Institution</label>
                        <input
                          placeholder="Organization name"
                          value={form.company}
                          onChange={update("company")}
                        />
                      </div>
                      <div className="f-grp">
                        <label>Country</label>
                        <input
                          placeholder="Your country"
                          value={form.country}
                          onChange={update("country")}
                        />
                      </div>
                    </div>
                    <div className="f-grp">
                      <label>Service of Interest</label>
                      <select value={form.service} onChange={update("service")}>
                        <option value="">Select a service...</option>
                        {SOLUTIONS.map((s) => (
                          <option key={s.title}>{s.title}</option>
                        ))}
                      </select>
                    </div>
                    <div className="f-grp">
                      <label>How can we help? *</label>
                      <textarea
                        required
                        placeholder="Tell us about your project or inquiry..."
                        value={form.message}
                        onChange={update("message")}
                      />
                    </div>
                    {error && <p className="form-error">{error}</p>}
                    <button
                      type="submit"
                      className="sub-btn"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message →"}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
